var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "location-dropdown__option",
      class: {
        "location-dropdown__option--sold-out": _vm.dropDownItem.disabled,
      },
      attrs: { "data-test-dropdown-item": _vm.dropDownItem.value },
      on: {
        click: function ($event) {
          return _vm.onSelectDropdownItem(_vm.dropDownItem)
        },
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.dropDownItem.title) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }